import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel';
import { Contributors } from '@/types/contributors';
import Autoplay from 'embla-carousel-autoplay';
import Image from 'next/image';
import React from 'react';

interface ContributorCarouselProps {
    title?: string;
    contributorList: Contributors[];
    minQty: number;
    customSpacing?: string;
}

function AppCarousel({ contributorList }: { contributorList: Contributors[] }) {
    const maxWidows: number = 1096;
    const contributorLength: number = contributorList.length;
    const currentWidth = contributorLength * 90;

    const maxW: number = currentWidth > maxWidows ? maxWidows : currentWidth;

    const plugin = React.useRef(Autoplay({ delay: 2000, stopOnInteraction: false, stopOnMouseEnter: true }));

    return (
        <div className="max-w-full" style={{ width: `${maxW}px` }}>
            <Carousel
                plugins={[plugin.current]}
                className="mx-5"
                opts={{
                    align: 'start',
                    loop: true,
                    slidesToScroll: 5,
                }}
            >
                <CarouselContent>
                    {contributorList.map((element: Contributors) => (
                        <CarouselItem key={element.id} className={`basis-1/${contributorList.length}`}>
                            <Image
                                className="rounded-[13px] bg-black"
                                src={element.src}
                                height={91}
                                width={91}
                                alt={`Logo ${element.name}`}
                                title={element.name}
                            />
                        </CarouselItem>
                    ))}
                </CarouselContent>
                <CarouselPrevious
                    variant="ghost"
                    className="top-[calc(50%-5px)] text-center hidden lg:block cursor-pointer hover:bg-transparent text-[#656565]"
                />
                <CarouselNext
                    variant="ghost"
                    className="top-[calc(50%-5px)] text-center hidden lg:block cursor-pointer hover:bg-transparent text-[#656565]"
                />
            </Carousel>
        </div>
    );
}

function AppList({ contributorList, spacing = '20px' }: { contributorList: Contributors[]; spacing?: string }) {
    return (
        <div className="flex" style={{ gap: spacing }}>
            {contributorList.map((element: Contributors) => (
                <Image
                    key={element.id}
                    className="rounded-[13px] bg-black"
                    src={element.src}
                    height={91}
                    width={91}
                    alt={`Logo ${element.name}`}
                    title={element.name}
                />
            ))}
        </div>
    );
}

export default function ContributorCarousel({
    title,
    contributorList,
    minQty,
    customSpacing,
}: ContributorCarouselProps) {
    const contributorLenght: number = contributorList.length;

    return (
        <>
            {title ? <h4 className="text-lg text-center mt-5 font-normal">{title}</h4> : null}
            {contributorLenght > minQty ? (
                <>
                    <AppCarousel contributorList={contributorList} />
                </>
            ) : (
                <>
                    <AppList contributorList={contributorList} spacing={customSpacing} />
                </>
            )}
        </>
    );
}
